//  React TS Base Styles
import borders from '../base/borders'
import colors from '../base/colors'

//  React TS Helper Functions
import pxToRem from '../functions/pxToRem'

const { borderRadius } = borders
const { light } = colors

// types
type Types = any

const linearProgress: Types = {
  styleOverrides: {
    root: {
      height: pxToRem(6),
      borderRadius: borderRadius.md,
      overflow: 'visible',
      position: 'relative',
    },

    colorPrimary: {
      backgroundColor: light.main,
    },

    colorSecondary: {
      backgroundColor: light.main,
    },

    bar: {
      height: pxToRem(6),
      borderRadius: borderRadius.sm,
      position: 'absolute',
      transform: 'translate(0, 0) !important',
      transition: 'width 0.6s ease !important',
    },
  },
}

export default linearProgress
